import React from "react";
import { usePokemonMemory } from "../context/PokemonMemoryContext";

const GameOverComponent = () => {
  const { updateGameState, gameState } = usePokemonMemory();
  const currentDifficulty = gameState.difficulty;
  let bestTime = gameState.easyBestTime;
  if (currentDifficulty === "Medium") {
    bestTime = gameState.mediumBestTime;
  } else if (currentDifficulty === "Hard") {
    bestTime = gameState.hardBestTime;
  }

  return (
    <div className="text-center py-8">
      <h1 className="text-4xl font-bold text-green-600 mb-4">Nice job!</h1>
      <div className="text-xl mb-2">Your time was {gameState.currentTime} seconds.</div>
      <div className="text-xl mb-6">
        Your best time for {gameState.difficulty} difficulty is {bestTime} seconds.
      </div>
      <button
        className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-8 rounded-lg transition-colors text-lg"
        onClick={() => {
          updateGameState({
            ...gameState,
            difficulty: "",
            isGameOver: false,
            currentTime: 0,
          });
        }}
      >
        Play Again
      </button>
    </div>
  );
};

export default GameOverComponent;
